import HomeOutline from './HomeOutline';
import HomeSolid from './HomeSolid';
import Calendar from './Calendar';
import Chat from './Chat';
import Phone from './Phone';
import Log from './Log';
import Callback from './Callback';
import Restart from './Restart';
import Question from './Question';
import AlertExplanation from './AlertExplanation';
import CaretRight from './CaretRight';
import CaretLeft from './CaretLeft';
import CaretDown from './CaretDown';
import CaretUp from './CaretUp';
import Checkmark from './Checkmark';
import VerticalDots from './VerticalDots';
import Share from './Share';
import Flag from './Flag';
import Add from './Add';
import LoaderRing from './LoaderRing';
import CaretLeftSmall from './CaretLeftSmall';
import HideThick from './HideThick';
import ShowThick from './ShowThick';
import AlertExplanationLite from './AlertExplanationLite';
import External from './External';
import NoPermissions from './NoPermissions';
import Info from './Info';
import NotAvailable from './NotAvailable';
import CloseButton from './CloseButton';
import SendIcon from './SendIcon';
import ErrorIcon from './ErrorIcon';
import PremiumUserButton from './PremiumUserButton';
import StandardUserButton from './StandardUserButton';
import AutodeskAvatarIcon from './AutodeskAvatarIcon';
import DownloadIcon from './DownloadIcon';
import CloseIcon from './CloseIcon';
import AttachIcon from './AttachIcon';
import FileIcon from './FileIcon';
import SheerId from './SheerId';

export default {
  HomeOutline,
  HomeSolid,
  Calendar,
  Chat,
  Phone,
  Log,
  Callback,
  Restart,
  Question,
  AlertExplanation,
  CaretRight,
  CaretLeft,
  CaretDown,
  CaretUp,
  Checkmark,
  VerticalDots,
  Share,
  Flag,
  Add,
  LoaderRing,
  CaretLeftSmall,
  HideThick,
  ShowThick,
  AlertExplanationLite,
  External,
  NoPermissions,
  Info,
  NotAvailable,
  CloseButton,
  SendIcon,
  ErrorIcon,
  PremiumUserButton,
  StandardUserButton,
  AutodeskAvatarIcon,
  DownloadIcon,
  CloseIcon,
  AttachIcon,
  FileIcon,
  SheerId
};
